import PurchaseTypesEnum from '@/common/enums/purchase-types.enum';
import HeaderBidderConfigPipelineNodeActions from '@/common/models/headerBidder/HeaderBidderConfigPipelineNodeActions';
import HeaderBidderConfigPipelineNodeCategories from '@/common/models/headerBidder/HeaderBidderConfigPipelineNodeCategories';
import HeaderBidderConfigPipelineNodeProvenance, {
  IHeaderBidderConfigPipelineNodeProvenance,
} from '@/common/models/headerBidder/HeaderBidderConfigPipelineNodeProvenance';
import HeaderBidderConfigPipelineNodePurchaseTypes from '@/common/models/headerBidder/HeaderBidderConfigPipelineNodePurchaseTypes';
import Validatable, { IExtraValidation } from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IHeaderBidderConfigPipelineNodeAPI {
  action: string;
  category: string;
  orgs: any[]; // Define the appropriate type for orgs
  provenance: IHeaderBidderConfigPipelineNodeProvenance; // Define the appropriate type for provenance
  purchaseType: PurchaseTypesEnum;
}

export default class HeaderBidderConfigPipelineNode extends Validatable {
  action: string;

  category: string;

  orgs: any[]; // Define the appropriate type for orgs

  provenance: IHeaderBidderConfigPipelineNodeProvenance; // Define the appropriate type for provenance

  purchaseType: PurchaseTypesEnum;

  constructor({
    action = HeaderBidderConfigPipelineNodeActions[0],
    category = HeaderBidderConfigPipelineNodeCategories.auction[0],
    orgs = [],
    provenance = HeaderBidderConfigPipelineNodeProvenance,
    purchaseType = HeaderBidderConfigPipelineNodePurchaseTypes,
  }: {
    action: string;
    category: string;
    orgs: any[]; // Define the appropriate type for orgs
    provenance: IHeaderBidderConfigPipelineNodeProvenance; // Define the appropriate type for provenance
    purchaseType: PurchaseTypesEnum;
  } = {}) {
    super();
    this.action = action;
    this.category = category;
    this.orgs = orgs;
    this.provenance = provenance;
    this.purchaseType = purchaseType;
  }

  static fromApi(apiObject: IHeaderBidderConfigPipelineNodeAPI): HeaderBidderConfigPipelineNode {
    return new HeaderBidderConfigPipelineNode({
      action: apiObject.action,
      category: apiObject.category,
      orgs: apiObject.orgs,
      provenance: apiObject.provenance,
      purchaseType: apiObject.purchaseType,
    });
  }

  toApi(): IHeaderBidderConfigPipelineNodeAPI {
    return {
      action: this.action,
      category: this.category,
      orgs: this.orgs,
      provenance: this.provenance,
      purchaseType: this.purchaseType,
    };
  }

  getExtraValidation(): Record<string, IExtraValidation> {
    const extras: Record<string, IExtraValidation> = {};
    if (this.action.id === 'auction' && this.orgs.length === 1) {
      extras.parallelAuction = {
        message: i18n.global.t('messages.parallelAuctionRequireTwoOrMoreSSPs'),
        preEvaluated: true,
      };
    }
    return extras;
  }

  static validatorCreateRules(): Record<string, string> {
    return {};
  }
}
